// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { Box, Tab } from '@mui/material';
// Components, Layouts, Pages
import ChildrenPage from '~/pages/common/childrenPage/ChildrenPage';
import { BaseTabList } from '~/components/common';
import { ContactInformationPage, ContactActivitiesPage, ContactDocumentPage } from '~/pages/template';
// Others
import { IBaseTabItem } from '~/utils/interface/common';
import { ContactDetailTabsEnum, RoleEnum } from '~/utils/enum/common';
import { StorageEnum } from '~/utils/enum/base';
import { EMPTY_STRING } from '~/utils/constants/common';
import { adminRouteAbsolute } from '~/utils/routes/admin';
import { staffRouteAbsolute } from '~/utils/routes/staff';
// Styles, images, icons
import styles from './ContactDetail.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const ContactDetail = (props: Props) => {
  //#region Destructuring Props

  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/contact', 'common/base']);
  const { hash } = useLocation();
  const navigate = useNavigate();
  const { id: contactId } = useParams();

  const getMenuItems = useCallback(() => {
    const items: Array<IBaseTabItem> = [
      { label: ContactDetailTabsEnum.INFORMATION, component: <ContactInformationPage /> },
    ];

    items.push({ label: ContactDetailTabsEnum.ACTIVITIES, component: <ContactActivitiesPage /> });

    items.push({ label: ContactDetailTabsEnum.DOCUMENT, component: <ContactDocumentPage /> });

    setTabItems(items);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactId]);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [tabKey, setTabKey] = useState<string>(ContactDetailTabsEnum.INFORMATION);
  const [tabItems, setTabItems] = useState<IBaseTabItem[]>([]);
  const [currentRole] = useState<string>(localStorage.getItem(StorageEnum.ROLE) ?? EMPTY_STRING);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    if (hash) setTabKey(hash.slice(1));
  }, [hash]);

  useEffect(() => {
    getMenuItems();
  }, [getMenuItems]);
  //#endregion Implement Hook

  //#region Handle Function
  const handleBackToContacts = () => {
    switch (currentRole) {
      case RoleEnum.ADMIN:
        navigate(adminRouteAbsolute.contacts);
        break;

      case RoleEnum.STAFF:
        navigate(staffRouteAbsolute.contacts);
        break;
    }
  };

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    navigate(`#${newValue}`);
  };

  const renderTabContent = () => {
    const item = tabItems.find((tabItem: IBaseTabItem) => {
      return tabKey === tabItem.label;
    });

    return item?.component;
  };
  //#endregion Handle Function

  return (
    <ChildrenPage
      id='contactDetailPage'
      title={t('contact_detail_title')}
      onBackToPreviousPage={handleBackToContacts}
    >
      <>
        <BaseTabList value={tabKey} onChange={handleTabChange}>
          {tabItems.map((item, index) => (
            <Tab
              value={item.label}
              key={index}
              label={t(`tab_label_${item.label}`)}
              className={cx('tabItem')}
            />
          ))}
        </BaseTabList>

        <Box component={'div'} className={cx('tabContent')}>
          {renderTabContent()}
        </Box>
      </>
    </ChildrenPage>
  );
};

export default ContactDetail;
